import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @file Created on Thu Sep 27 2018
 * @author BPo
 */


import { jsonConversions, SettingsConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../../shared/logger';
/**
 * Settings object transport layer
 */

export var SettingsLayer =
/*#__PURE__*/
function () {
  function SettingsLayer() {
    var _this = this;

    _classCallCheck(this, SettingsLayer);

    /**
     * Converts all returned settings (e.g. after create / update / ...)
     */
    this.mapResponseSettingsData = function (response) {
      var settingsMap = new Map();
      (response.data.result || []).map(function (item) {
        var settings = _this.getConverter().toObject(item, jsonConversions);

        var settingsArr = settingsMap.get(settings.priceZoneId) || [];
        settingsArr.push(settings);
        settingsMap.set(settings.priceZoneId, settingsArr);
      });
      return settingsMap;
    };

    this.copyZones = function (data) {
      var copyZonesPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS_COPY_ZONES)).post(data, {
        responseType: 'json'
      }).then(_this.mapResponseSettingsData).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return copyZonesPromise;
    };

    this.copyCategory = function (data) {
      var copyCategoryPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS_COPY_CATEGORIES)).post(data, {
        responseType: 'json'
      }).then(_this.mapResponseSettingsData).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return copyCategoryPromise;
    };

    this.initOptimizationGraph = function (params) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS_OPTIMIZATION_GRAPH)).post(params, {
                  responseType: 'json'
                });

              case 2:
                _ref = _context.sent;
                data = _ref.data;
                return _context.abrupt("return", data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };

    this.getOptimizationGraph = function (optimizationId) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _ref2, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS_OPTIMIZATION_GRAPH, "/").concat(optimizationId)).get({
                  responseType: 'json'
                });

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;
                return _context2.abrupt("return", data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    };
  }

  _createClass(SettingsLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Gets all settings for the specific product category.
     * @returns Grouped settings objects by price zone IDs
     */

  }, {
    key: "getGroupedByZone",
    value: function getGroupedByZone(path, catId, params) {
      // NOTE: BPo Maybe will be better to return the array of Settings and handle grouping by zones
      // in some computed value...
      var promise = api("".concat(CONSTANTS.APP.API_HOST).concat(path).concat(catId)).get({
        responseType: 'json',
        params: params
      }).then(this.mapResponseSettingsData).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return promise;
    }
    /**
     * Method deletes general settings
     * As response gets object with parameter{delete: boolean}
     * @param params - Delete query params
     */

  }, {
    key: "delete",
    value: function _delete(params) {
      var deletePromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS)).delete({
        responseType: 'json',
        params: params
      }).then(function (response) {
        return response.data.deleted === true;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return deletePromise;
    }
  }, {
    key: "update",
    value: function update(items) {
      var _this2 = this;

      var postData = items.map(function (item) {
        return _this2.getConverter().toDocument(item, jsonConversions);
      });
      var updatePromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS_SAVE)).post(postData, {
        responseType: 'json'
      }).then(this.mapResponseSettingsData).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return updatePromise;
    }
  }]);

  return SettingsLayer;
}();

__decorate([Inject, __metadata("design:type", SettingsConverter)], SettingsLayer.prototype, "converter", void 0);